































 import {Component, Prop, Vue} from 'vue-property-decorator';
 import Likes from "../Likes.vue";
 import {Rating} from "@api/models/Rating";
 import LiveSvg from '../../../assets/svg/live.svg';

@Component({
     components: { Likes, LiveSvg }
 })
 export default class CountersPanel extends Vue {

     @Prop({ default: 0}) onlineCount?: number;
     @Prop({ default: {}}) likes?: Rating;
     @Prop({ default: 0 }) commentsCount: number;

     get likesCount() {
         return this.likes?.count || 0;
     }

     get isOnlineHidden(): boolean {
         return this.$store.getters['events/selectedEventViewParam']('usersWatchingPanel', null)?.showGenerallyAllUsersForSession === true;
     }
 }
